<template>
  <el-dialog width="40%"  :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false" @close="qx()">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '240px' : '240px'">
      <el-form-item class="styW" label="商户标识" prop="appId">
        <el-input v-model="dataForm.appId" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item class="styW" label="商户代码编号" prop="merNo">
        <el-input v-model="dataForm.merNo" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item class="styW" label="资金方" prop="userId">
        <el-select style="width: 240px;"  v-model="dataForm.userId" filterable clearable placeholder="请选择">
            <el-option v-for="item in  fundList" :key="item.userId" :value="item.userId" :label="item.deptName"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="styW" label="父ID(对应小贷在该表的主键)" prop="parentId">
        <el-input v-model="dataForm.parentId" placeholder="请输入" disabled></el-input>
      </el-form-item>
      <el-form-item class="styW" label="公司名称" prop="companyName">
        <el-input v-model="dataForm.companyName" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item class="styW" label="统统付商户的私钥证书名称" prop="keyStorePath">
        <el-input v-model="dataForm.keyStorePath" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item class="styW" label="统统付提供给商户的私钥证书密码" prop="keyStorePassword">
        <el-input v-model="dataForm.keyStorePassword" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item class="styW" label="统统付提供的公钥证书名称" prop="publicKeyStorePath">
        <el-input v-model="dataForm.publicKeyStorePath" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item class="styW" label="统统付虚拟账号" prop="virtualAccount">
        <el-input v-model="dataForm.virtualAccount" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item class="styW" label="支付方式" prop="payType">
        <el-select style="width: 240px;"  v-model="dataForm.payType" filterable clearable placeholder="请选择">
            <el-option v-for="(item,index) in  payTypeList" :key="index" :value="item.value" :label="item.label"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="qx()">{{ $t('cancel') }}</el-button>
      <el-button :disabled="isConfirm" v-loading="isConfirm" type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from "lodash/debounce"
export default {
  data() {
    return {
      visible: false,
      isConfirm:false,
      fundList:[],
      payTypeList:[],
      dataForm: {
        id: "",
        appId: "",
        merNo: "",
        userId: "",
        parentId: "",
        companyName: "",
        keyStorePath:"",
        keyStorePassword:"",
        publicKeyStorePath:"",
        virtualAccount:"",
        payType:"",
      },
    }
  },
  computed: {
    dataRule() {
      return {
        appId: [{ required: true, message: this.$t("validate.required"), trigger: "blur" }],
        merNo: [{ required: true, message: this.$t("validate.required"), trigger: "blur" }],
        userId: [{ required: true, message: this.$t("validate.required"), trigger: "blur" }],
        parentId: [{ required: true, message: this.$t("validate.required"), trigger: "blur" }],
        companyName: [{ required: true, message: this.$t("validate.required"), trigger: "blur" }],
        keyStorePath: [{ required: true, message: this.$t("validate.required"), trigger: "blur" }],
        keyStorePassword: [{ required: true, message: this.$t("validate.required"), trigger: "blur" }],
        publicKeyStorePath: [{ required: true, message: this.$t("validate.required"), trigger: "blur" }],
        virtualAccount: [{ required: true, message: this.$t("validate.required"), trigger: "blur" }],
        payType: [{ required: true, message: this.$t("validate.required"), trigger: "blur" }],
      }
    },
  },
  created() {
    this.$http.get(`/sys/dict/data/list?dataType=ttf_pay_type`).then(r=>{
     this.payTypeList = r.data.data ? r.data.data.map(item => ({value:item.dictValue,label:item.dictLabel})) : []
    })
  },
  methods: { 
    init () {
      this.visible = true
      this.$http.get('/ttf/account/page',
        {
          params: {
            parentId:"0",
          }
        }
      ).then(res=>{
        if (res.data.code !== 0) {
          return this.$message.error(res.data.msg)
        }
        this.dataForm.parentId = res.data.data.list[0].id
        
      })
      this.$http.get('/sys/user/queryUserIdList').then(res=>{
        this.fundList = res.data.data
      })
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields()
        if (this.dataForm.id) {
          this.getInfo()  
        }
        
      })
     
    },
    // 获取信息
    getInfo() {
      this.$http
        .get(`/ttf/account/info/${this.dataForm.id}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.dataForm = {
            ...this.dataForm,
            ...res.data,
          }
          this.dataForm.payType = this.dataForm.payType.toString()
        })
        .catch(() => {})
    },
    qx(){
      this.visible = false
      this.$refs.dataForm.resetFields()
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function () {
        this.$refs["dataForm"].validate((valid) => {
          if (!valid) {
            return false
          }
          
          this.isConfirm = true
          this.$http[!this.dataForm.id ? "post" : "put"](`/ttf/account`, this.dataForm)
            .then(({ data: res }) => {
              this.isConfirm = false
              if (res.code !== 0) {
                return this.$message.error(res.msg)
              }
              this.$message({
                message: this.$t("prompt.success"),
                type: "success",
                duration: 500,
                onClose: () => {
                  this.visible = false
                  this.$emit("refreshDataList")
                },
              })
            })
            .catch(() => {
              this.isConfirm = false
            })
        })
      },
      1000,
      { leading: true, trailing: false }
    ),
    
  },
}
</script>
<style scoped lang="scss">
::v-deep .el-dialog{
  min-width: 700px;
}
.styW{
  width: 480px;
 }
 
</style>